/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @angular-eslint/component-selector */
import { NgClass, NgFor, NgIf } from "@angular/common";
import { Component, OnDestroy, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { ActivatedRoute, Router, RouterLink, RouterOutlet } from "@angular/router";
import { FuseLoadingBarComponent } from "@fuse/components/loading-bar";
import { FuseNavigationService, FuseVerticalNavigationComponent } from "@fuse/components/navigation";
import { FuseMediaWatcherService } from "@fuse/services/media-watcher";
import { TranslocoModule } from "@jsverse/transloco";
import { ICONE_MODULO } from "app/core/icons/modulos";
import { NavigationService } from "app/core/navigation/navigation.service";
import { Navigation } from "app/core/navigation/navigation.types";
import { LanguagesComponent } from "app/layout/common/languages/languages.component";
import { MessagesComponent } from "app/layout/common/messages/messages.component";
import { UserComponent } from "app/layout/common/user/user.component";
import { EzvEmpresaAtivaComponent } from "app/shared/components/empresa-ativa/empresa-ativa.component";
import { TenantSwitchComponent } from "app/shared/components/tenant-switch/tenant-switch.component";
import { environment } from "environments";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "compact-layout",
  templateUrl: "./compact.component.html",
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FuseLoadingBarComponent,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    RouterLink,
    LanguagesComponent,
    MessagesComponent,
    UserComponent,
    NgClass,
    NgIf,
    NgFor,
    RouterOutlet,
    FuseVerticalNavigationComponent,
    TranslocoModule,
    EzvEmpresaAtivaComponent,
    TenantSwitchComponent,
  ],
})
export class CompactLayoutComponent implements OnInit, OnDestroy {
  isScreenSmall: boolean;
  navigation: Navigation;

  /**
   * Módulos acessíveis pelo seletor do cabeçalho; a rota de cada um define o módulo ativo
   */
  modules = [
    { id: "BAS", title: "Básico", icon: ICONE_MODULO.BAS, link: "/dashboards" },
    { id: "EST", title: "Estoque", icon: ICONE_MODULO.EST, link: "/estoque" },
    { id: "ALU", title: "Aluguel", icon: ICONE_MODULO.ALU, link: "/aluguel" },
  ];
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  /**
   * Constructor
   */
  constructor(
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private _navigationService: NavigationService,
    private _fuseMediaWatcherService: FuseMediaWatcherService,
    private _fuseNavigationService: FuseNavigationService,
  ) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Indica se o build não é de produção
   */
  get isAmbienteTeste(): boolean {
    return environment.appMode !== "production";
  }

  /**
   * Getter for current year
   */
  get currentYear(): number {
    return new Date().getFullYear();
  }

  get moduleName(): string {
    const module = this._navigationService.currentModule;
    switch (module) {
      case "CTB":
        return "Contábil";
      case "FIS":
        return "Livros fiscais";
      case "EST":
        return "Estoque";
      case "ALU":
        return "Aluguel";
      default:
        return "Erp";
        break;
    }
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Subscribe to navigation data
    this._navigationService.navigation$.pipe(takeUntil(this._unsubscribeAll)).subscribe((navigation: Navigation) => {
      this.navigation = navigation;
    });

    // Subscribe to media changes
    this._fuseMediaWatcherService.onMediaChange$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(({ matchingAliases }) => {
        // Check if the screen is small
        this.isScreenSmall = !matchingAliases.includes("md");
      });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Toggle navigation
   *
   * @param name
   */
  toggleNavigation(name: string): void {
    // Get the navigation
    const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(name);

    if (navigation) {
      // Toggle the opened status
      navigation.toggle();
    }
  }
}
